export const VIEW_MODE_URL_PARAM_KEY = 'v'
export const NEW_VIEW_MODE_URL_PARAM_VALUE = '2'
export const OLD_VIEW_MODE_URL_PARAM_VALUE = '1'
